export const api = require("./API/api-bco.svg");
export const readDB = require("./Base de datos/bd-bco.svg");
export const loop = require("./Ciclo/ciclo-bco.svg");
export const deleteBd = require("./Eliminar info base de datos/eibd-bco.svg");
export const error = require("./Error/error-bco.svg");
export const writeBd = require("./Escritura base de datos/ebd-bco.svg");
export const func = require("./Funcion/fx-bco.svg");
export const settings = require("./Icono de ajustes/ajuste-bco.svg");
export const info = require("./Icono Info/info-bco.svg");
export const conditional = require("./If/if-bco.svg");
export const dbModel = require("./Modelo/modelo-bco.svg");
export const rtnNode = require("./Return/return-bco.svg");
